import type { FC, SVGProps } from "react";
import KkScrewGraphic, { type KkScrewSize, type MillimetersToPixels } from "./KkScrew";

type FlatFlipProps = SVGProps<SVGSVGElement> & {
  screw?: Partial<KkScrewSize> | null;
};

export const FLAT_FLIP_LOWER_BASE_WIDTH_MM = 27;
export const FLAT_FLIP_TOTAL_HEIGHT_MM = 8;
export const FLAT_FLIP_BASE_STACK_HEIGHT_MM = 4;
const UPPER_BASE_WIDTH = 23;
const UPPER_BASE_HEIGHT = 2;
const LOWER_PROTRUSION_WIDTH = 7;
const LOWER_PROTRUSION_VISIBLE_HEIGHT = FLAT_FLIP_TOTAL_HEIGHT_MM - FLAT_FLIP_BASE_STACK_HEIGHT_MM;
const FILL_COLOR = "#b5b5b5";
const STROKE_COLOR = "#3f3f3f";
const STROKE_WIDTH = 0.16;
const millimetersToGraphicUnits: MillimetersToPixels = (millimeters) => millimeters;

const FlatFlip: FC<FlatFlipProps> = ({ screw, ...props }) => {
  const upperBaseX = (FLAT_FLIP_LOWER_BASE_WIDTH_MM - UPPER_BASE_WIDTH) / 2;
  const lowerBaseY = UPPER_BASE_HEIGHT;
  const lowerBaseHeight = FLAT_FLIP_TOTAL_HEIGHT_MM - LOWER_PROTRUSION_VISIBLE_HEIGHT - lowerBaseY;
  const lowerProtrusionX = (FLAT_FLIP_LOWER_BASE_WIDTH_MM - LOWER_PROTRUSION_WIDTH) / 2;
  const lowerProtrusionBottomWidth = LOWER_PROTRUSION_WIDTH * 0.68;
  const lowerProtrusionBottomX = (FLAT_FLIP_LOWER_BASE_WIDTH_MM - lowerProtrusionBottomWidth) / 2;
  const lowerProtrusionShoulderY = FLAT_FLIP_TOTAL_HEIGHT_MM - 1.25;
  const upperBaseCornerSize = 0.7;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${FLAT_FLIP_LOWER_BASE_WIDTH_MM} ${FLAT_FLIP_TOTAL_HEIGHT_MM}`}
      aria-hidden="true"
      overflow="visible"
      shapeRendering="geometricPrecision"
      {...props}
    >
      {screw && (
        <KkScrewGraphic
          screw={screw}
          toPixels={millimetersToGraphicUnits}
          centerX={FLAT_FLIP_LOWER_BASE_WIDTH_MM / 2}
          headBottomY={0}
        />
      )}
      <path
        d={`M ${lowerProtrusionX} ${lowerBaseY}
          H ${lowerProtrusionX + LOWER_PROTRUSION_WIDTH}
          V ${lowerProtrusionShoulderY}
          L ${lowerProtrusionBottomX + lowerProtrusionBottomWidth} ${FLAT_FLIP_TOTAL_HEIGHT_MM}
          H ${lowerProtrusionBottomX}
          L ${lowerProtrusionX} ${lowerProtrusionShoulderY}
          Z`}
        fill={FILL_COLOR}
        stroke={STROKE_COLOR}
        strokeLinejoin="miter"
        strokeWidth={STROKE_WIDTH}
      />
      <path
        d={`M ${upperBaseX} ${lowerBaseY}
          V ${upperBaseCornerSize}
          Q ${upperBaseX} 0 ${upperBaseX + upperBaseCornerSize} 0
          H ${upperBaseX + UPPER_BASE_WIDTH - upperBaseCornerSize}
          Q ${upperBaseX + UPPER_BASE_WIDTH} 0 ${upperBaseX + UPPER_BASE_WIDTH} ${upperBaseCornerSize}
          V ${lowerBaseY}
          Z`}
        fill={FILL_COLOR}
        stroke={STROKE_COLOR}
        strokeWidth={STROKE_WIDTH}
      />
      <rect
        x="0"
        y={lowerBaseY}
        width={FLAT_FLIP_LOWER_BASE_WIDTH_MM}
        height={lowerBaseHeight}
        fill={FILL_COLOR}
        stroke={STROKE_COLOR}
        strokeWidth={STROKE_WIDTH}
      />
    </svg>
  );
};

export default FlatFlip;
